<template>
  <div>
    <div v-if="Business">
      <div v-if="$vuetify.breakpoint.xsOnly">
        <div class="text-center mt-4">
          <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />

          <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
          <div v-if="Business.phoneNumber">
            {{ Business.phoneNumber | USPhoneNumber }}
          </div>
          <div>
            <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
            }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
            <span v-if="Business.zip">{{ Business.zip }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
          <v-flex>
            <img v-if="Business.imageUrl" height="100" :src="Business.imageUrl" alt="Logo" />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <div class="text-right">
              <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
              <div>
                <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
                }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
                <span v-if="Business.zip">{{ Business.zip }}</span>
              </div>
              <div v-if="Business.phoneNumber">
                {{ Business.phoneNumber | USPhoneNumber }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-container grid-list-lg :fluid="$vuetify.breakpoint.xsOnly" v-if="Counters">
      <v-card outlined rounded >
        <v-data-table
          :headers="headers"
          :items="Counters"
          dark
          hide-default-footer
        >
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left">{{ item.name }}</td>
              <td class="text-right">
                <span class="mr-7">{{ item.metadata && item.metadata.needed ? item.metadata.needed : 0 }}</span>
              </td>
              <td class="text-right">
                <span class="mr-7">{{ item.metadata && item.metadata.received ? item.metadata.received : 0 }}</span>
              </td>
              <td class="text-right">
                <span class="mr-7">{{ balance(item) }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
import counterService from "../service.js";
export default {
  name: 'counter-controller',
  data() {
    return {
      Business: null,
      Counters: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Sponsor Needed",
          align: "right",
          value: "metadata.needed",
          sortable: true,
        },
        {
          text: "Sponsored",
          value: "metadata.received",
          align: "right",
          sortable: true,
        },
        {
          text: "Balance",
          value: "balance",
          align: "right",
          sortable: true,
        },
      ],
    } 
  },
  created() {
    if(!this.$route.params.id)
      this.$router.push({ name: "pagenotfound" });
    this.loadBusiness()
    this.loadCounter()
  },
  methods: {
    balance(row){
      let balance = row.metadata.needed ? parseInt(row.metadata.needed) : 0
      balance -= row.metadata.received ? parseInt(row.metadata.received) : 0
      return balance
    },
    loadBusiness() {
      let id = this.$route.params.id;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          this.Business = response.data;
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    loadCounter() {
      let id = this.$route.params.id;
      counterService
        .getPublicCounterList({ key: id})
        .then((response) => {
          this.Counters = response.data
        })
        .catch((error) => {
          console.log("error getting Counters", error);
        });
    },
  }
  
}
</script>

<style scoped>
</style>